export default __webpack_public_path__ + "static/media/medicines_request.0ca0fb79.svg";